import { render, staticRenderFns } from "./GenderBarChart.vue?vue&type=template&id=7356b05d&scoped=true&"
import script from "./GenderBarChart.vue?vue&type=script&lang=js&"
export * from "./GenderBarChart.vue?vue&type=script&lang=js&"
import style0 from "./GenderBarChart.vue?vue&type=style&index=0&id=7356b05d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7356b05d",
  null
  
)

export default component.exports